import { dayjs } from '@umanforge/common';
import React, { useEffect, useState } from 'react';

const Clock: React.FC = () => {
  const [ currentTime, setCurrentTime ] = useState( dayjs() );

  useEffect( () => {
    const interval = setInterval( () => {
      setCurrentTime( dayjs() );
    }, 1000 );
    return () => { return clearInterval( interval ); };
  }, [] );

  // html
  return (
    <div>
      { currentTime.format( 'LT' ) }
    </div>
  );
};

export { Clock };